module.exports = __webpack_public_path__ + "img/over.c5e933f7.png";